"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_client_service_1 = require("../../../axios-client/axios-client.service");
var agent_const_1 = require("./agent.const");
/**
 * AgentService
 * @class
 */
var AgentService = /** @class */ (function () {
    function AgentService() {
    }
    /**
     * Returns user operators
     * @returns `Operator[]`
     */
    AgentService.prototype.getOperators = function () {
        return axios_client_service_1.axiosClientInstance.get(agent_const_1.AGENT_ENDPOINT.getOperators);
    };
    return AgentService;
}());
/**
 * AgentService Class Instance
 * @namespace
 */
exports.agent = new AgentService();
